import React, { useState, useEffect } from "react";
import { Paper, Typography, useTheme, useMediaQuery } from "@mui/material";
import apiService from "../../../../../ApiService";
import { API_ENDPOINTS } from "../../../../../ApiService";
import { MainContainer } from "../../../styles/sharedStyles";
import Title from "../../../../components/title/Title";
import Section from "../../../../components/section/Section";
import { tokens } from "../../../../../theme";
import ExerciseListing from "./ExerciseListing";

// Extracted style for the heading
const headingStyle = {
  backgroundColor: "#1976d2",
  color: "#fff",
  p: 1,
  borderRadius: 1,
};

const ExerciseListingPage = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Data lists for dropdowns/checkboxes
  const [availableEquipments, setAvailableEquipments] = useState([]);
  const [availableTags, setAvailableTags] = useState([]);
  const [availableMuscles, setAvailableMuscles] = useState([]);
  const [allExercises, setAllExercises] = useState([]);
  const [availableFamilies, setAvailableFamilies] = useState([]);
  const [availableBodyPart, setAvailableBodyPart] = useState([]);
  const [filter, setFilter] = useState("");

  // Use aggregated endpoint to fetch all creation data in one call.
  useEffect(() => {
    const fetchCreationData = async () => {
      try {
        const response = await apiService.get(
          API_ENDPOINTS.FITNESS_GET_INFO_FOR_EXERCISE_CREATION
        );
        const data = response.data;
        setAllExercises(data.exercises);
        setAvailableEquipments(data.equipments);
        setAvailableTags(data.tags);
        setAvailableMuscles(data.muscles);
        setAvailableFamilies(data.families);
        setAvailableBodyPart(data.bodyParts);
      } catch (error) {
        console.error("Error fetching creation data:", error);
      }
    };
    fetchCreationData();
  }, []);

  // Basic filtering for the listing table (you can integrate the dropdown filters from your other component)
  const filteredExercises = allExercises.filter((ex) =>
    ex.name.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <MainContainer>
      <Title
        title="Liste des exercises"
        summary="Voici la liste des exercises de musculation"
      />
      <Section>
        <Paper
          elevation={3}
          sx={{
            p: 1.5, // smaller padding
            mb: 2,
            backgroundColor: colors.primary[400],
          }}
        >
          <Typography variant="body1" color={colors.grey[100]} align="left">
            Tu peux filtrer en utilisant les filtres
          </Typography>
        </Paper>
      </Section>

      {/* Reusable Exercises Table */}

      <ExerciseListing
        exercises={allExercises}
        headerColor={tokens(theme.palette.mode).primary[900]}
      />
    </MainContainer>
  );
};

export default ExerciseListingPage;
